module.exports = __webpack_public_path__ + "img/grade-2.8b6c566b.png";